// extracted by mini-css-extract-plugin
export default {"form":"dhOe9","button":"VnChW","info":"qDKC2","errorMessage":"CPOlL","infoItem":"gEr1E","infoText":"ZO0mQ","passwordIcon":"_5XVkx"};